const STATUS_COLORS: Record<string, string> = {
  '--1': 'bg-green-600',
  '--9': 'bg-green-600',
  '--10': 'bg-green-600',
  '--2': 'bg-link',
  '--3': 'bg-error',
  '--4': 'bg-error',
  '--7': 'bg-amber-400',
  'paid': 'bg-success',
  'negociated': 'bg-success',
  'refunded': 'bg-error',
  'waiting_refund': 'bg-error',
  'canceled': 'bg-primary-dark',
  'duplicated': 'bg-primary-dark',
  'expired': 'bg-primary-dark',
  'open': 'bg-link',
  'analysing': 'bg-link',
  'recovering': 'bg-amber-400',
  'waiting_payment': 'bg-amber-400',
  'scheduled': 'bg-amber-400'
};

export const TABLE_STATUS_BASE =
  'absolute p-0! z-[1] top-0 left-0 h-full w-[0.65rem] left-0 rounded-l-md translate-x-0 translate-y-0';

export function getStatusColor(status: string): string {
  return STATUS_COLORS[status] ?? '';
}
